import reduceReducers from "reduce-reducers";

import { SALE_STATUS } from "constants/actionTypes";

import {
  offlineCrudReducer,
  resetStateOnRoleChangeReducer,
} from "lib/reducers";
import { deserializeSaleStatus as deserializer } from "lib/serializers/saleStatus";

const saleStatusCrudReducer = offlineCrudReducer(SALE_STATUS, {
  deserializer,
});

const saleStatusReducer = reduceReducers(
  saleStatusCrudReducer,
  resetStateOnRoleChangeReducer,
);

export default saleStatusReducer;
